// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  background-color: rgb(229, 240, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
  gap: 1rem;
  height: 3rem;
}

.btn1 {
  color: #919EAB;
  background-color: #fff;
}

.btnpagination {
  color: #919EAB;
}

.button_pagination {
  border: none;
  height: 2rem;
  width: 2rem;
  color: black;
  background-color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
  /* color: #fff; */
  background-color: #fff !important;
  border-radius: 5px !important;
  color: #0C3688 !important;
  text-align: center;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  border: 1px solid #0C3688 !important;
}

.css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root {
  background-color: #fff !important;
  border-radius: 5px !important;
  color: #212B36 !important;
  text-align: center;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  border: 1px solid #DFE3E8 !important;
}`, "",{"version":3,"sources":["webpack://./src/component/Pagination/pagination.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EAEA,YAAA;AAAF;;AAGA;EACE,cAAA;EACA,sBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,oCAAA;AADF;;AAGA;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAAF","sourcesContent":[".pagination {\n  background-color: rgb(229, 240,255);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: .5rem 0;\n  gap: 1rem;\n  // width: 96%;\n  height: 3rem;\n}\n\n.btn1 {\n  color: #919EAB;\n  background-color: #fff;\n}\n\n.btnpagination {\n  color: #919EAB;\n}\n\n.button_pagination {\n  border: none;\n  height: 2rem;\n  width: 2rem;\n  color:black;\n  background-color: #fff;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {\n  /* color: #fff; */\n  background-color: #fff !important;\n  border-radius: 5px !important;\n  color: #0C3688 !important;\n  text-align: center;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  border: 1px solid #0C3688 !important;\n}\n.css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root {\n  background-color: #fff !important;\n  border-radius: 5px !important;\n  color: #212B36 !important;\n  text-align: center;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  border: 1px solid #DFE3E8 !important; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
